import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';

export function CodeBlock({ title, code, lang = 'python', testId }) {
  const [copied, setCopied] = useState(false);
  const handleCopy = () => { navigator.clipboard.writeText(code); setCopied(true); setTimeout(() => setCopied(false), 2000); };
  return (
    <div className="rounded-xl bg-[#0a0a0a] border border-white/[0.06] overflow-hidden" data-testid={testId}>
      <div className="flex items-center justify-between px-4 py-2 bg-white/[0.03] border-b border-white/[0.04]">
        <span className="text-xs text-gray-500">{title}</span>
        <button onClick={handleCopy} data-testid={testId ? `${testId}-copy` : undefined} className="flex items-center gap-1 text-[10px] text-gray-500 hover:text-white transition-colors">
          {copied ? <><Check className="w-3 h-3" /> Copied</> : <><Copy className="w-3 h-3" /> Copy</>}
        </button>
      </div>
      <pre className="p-4 text-xs text-gray-300 overflow-x-auto leading-relaxed"><code>{code}</code></pre>
    </div>
  );
}
